.button {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 9px 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  border: 1px solid var(--color-gray-20, rgb(0 0 0 / 20%));
  border-radius: 8px;

  &:disabled {
    background-color: var(--color-gray-30, rgb(0 0 0 / 30%));
  }

  &:disabled,
  &[aria-disabled='true'] {
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: var(--color-gray-5, rgb(0 0 0 / 5%));
  }
}

.icon {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
}

.downloadButton {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: start;

  p {
    font-size: 12px;
    font-weight: 300;
    line-height: 1.5;
  }
}

@media screen and (width >= 1024px) {
  .buttonScreen {
    font-size: 15px;
  }

  .downloadButtonScreen p {
    font-size: 13px;
  }
}

@container press-release-root (min-width: 1024px) {
  .buttonPressReleaseRoot {
    font-size: 15px;
  }

  .downloadButtonPressReleaseRoot p {
    font-size: 13px;
  }
}
